import axiosInstance from './axiosInstance';

const documentSequenceService = {
  listarConsecutivos: async () => {
    const response = await axiosInstance.get('/settings/document-sequences');
    return response.data;
  },

  // data = { prefix, last_value, padding, legend, declaration }
  actualizarConsecutivo: async (document, data) => {
    const response = await axiosInstance.put(`/settings/document-sequences/${document}`, data);
    return response.data;
  },
};

export default documentSequenceService;
